import React from "react";

// external package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp } from "@fortawesome/free-solid-svg-icons";

export default function socialMediaComponents() {
  return (
    <div className="social_media">
      <div className="title font-size-18 font-vietnam-600">Follow Us</div>
      <ul>
        <li>
          <a
            href="https://www.instagram.com/boss_iqbalar/"
            target="_blank"
            rel="noreferrer"
            className="d-flex justify-content-between align-items-center social_media_link"
          >
            <div className="name font-vietnam-300">Instagram</div>
            <div className="font font-vietnam-300">
              <FontAwesomeIcon icon={faArrowTrendUp} />
            </div>
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/muhammad-iqbal-aulia-rafi/"
            target="_blank"
            rel="noreferrer"
            className="d-flex justify-content-between align-items-center social_media_link"
          >
            <div className="name font-vietnam-300">LinkedIn</div>
            <div className="font font-vietnam-300">
              <FontAwesomeIcon icon={faArrowTrendUp} />
            </div>
          </a>
        </li>

        <li>
          <a
            href="https://medium.com/@boss_iqbal"
            target="_blank"
            rel="noreferrer"
            className="d-flex justify-content-between align-items-center social_media_link"
          >
            <div className="name font-vietnam-300">Medium</div>
            <div className="font font-vietnam-300">
              <FontAwesomeIcon icon={faArrowTrendUp} />
            </div>
          </a>
        </li>
        <li>
          <a
            href="https://github.com/Iqbalaulia"
            target="_blank"
            rel="noreferrer"
            className="d-flex justify-content-between align-items-center social_media_link"
          >
            <div className="name font-vietnam-300">Github</div>
            <div className="font font-vietnam-300">
              <FontAwesomeIcon icon={faArrowTrendUp} />
            </div>
          </a>
        </li>
      </ul>
    </div>
  );
}
